import { AddToChatButton } from '@apps/web/features/admin_agent_dock/add_to_chat_button';
import {
    buildAgentNoteChip,
    buildConversationChipFromNote,
} from '@apps/web/features/admin_agent_dock/chip_context_providers';
import { type AdminAgentNoteRead } from '@libraries/typescript/api_client';

// "+ add to chat" affordances for the agent-note surfaces (PHO-14459
// Part B). The note row the feed already fetched IS the kind's fast
// summary, so both resolvers build the chip synchronously from it —
// no extra read at click time.

export function NoteAddToChatButton({
    note,
    showLabel,
    idleLabel,
    className,
}: {
    readonly note: AdminAgentNoteRead;
    readonly showLabel?: boolean;
    readonly idleLabel?: string;
    readonly className?: string;
}) {
    return (
        <AddToChatButton
            kind="agent_note"
            entityId={note.id}
            resolveChip={() => Promise.resolve(buildAgentNoteChip(note))}
            showLabel={showLabel}
            idleLabel={idleLabel}
            className={className}
        />
    );
}

// Chip for the note's source SMS conversation. A note whose source is
// not an SMS conversation has no conversation identity, so no
// affordance renders.
export function NoteConversationAddToChatButton({
    note,
    showLabel,
    idleLabel,
    className,
}: {
    readonly note: AdminAgentNoteRead;
    readonly showLabel?: boolean;
    readonly idleLabel?: string;
    readonly className?: string;
}) {
    if (
        note.links.source_link_kind !== 'sms_conversation' ||
        !note.links.source_link_id
    ) {
        return null;
    }
    return (
        <AddToChatButton
            kind="conversation"
            entityId={note.links.source_link_id}
            resolveChip={() =>
                Promise.resolve(buildConversationChipFromNote(note))
            }
            showLabel={showLabel}
            idleLabel={idleLabel}
            className={className}
        />
    );
}
